/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { DescriptionPage_DifficultyLevel as DifficultyLevel } from '__generated__/graphql-types';

import { breakpoints } from '@coursera/cds-core';

import ReviewsVariantCProductCard from 'bundles/reviews/components/ReviewsVariantCProductCard';
import ReviewsVariantCRatingCard, {
  type RatingCountsByStar,
} from 'bundles/reviews/components/ReviewsVariantCRatingCard';

type Props = {
  courseId: string;
  courseName: string;
  description?: string | null;
  difficultyLevel?: DifficultyLevel | null;
  imageUrl?: string | null;
  marketingProductType?: string | null;
  partnerLogoUrl?: string | null;
  partnerName?: string | null;
  programSlug?: string;
  ratingCountsByStar?: RatingCountsByStar | null;
  ratingCount?: number | null;
  averageFiveStarRating?: number | null;
  skillTags?: Array<string>;
  totalDuration?: string | null;
};

const styles = {
  layout: css`
    display: grid;
    grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);
    gap: var(--cds-spacing-200);
    align-items: start;
    margin-top: var(--cds-spacing-300);
    margin-bottom: var(--cds-spacing-200);

    ${breakpoints.down('sm')} {
      grid-template-columns: 1fr;
    }
  `,
};

const ReviewsVariantCHeader = (props: Props) => {
  return (
    <div css={styles.layout}>
      <ReviewsVariantCRatingCard
        averageFiveStarRating={props.averageFiveStarRating}
        ratingCount={props.ratingCount}
        ratingCountsByStar={props.ratingCountsByStar}
      />
      <ReviewsVariantCProductCard
        courseId={props.courseId}
        courseName={props.courseName}
        description={props.description}
        difficultyLevel={props.difficultyLevel}
        imageUrl={props.imageUrl}
        marketingProductType={props.marketingProductType}
        partnerLogoUrl={props.partnerLogoUrl}
        partnerName={props.partnerName}
        programSlug={props.programSlug}
        skillTags={props.skillTags}
        totalDuration={props.totalDuration}
      />
    </div>
  );
};

export default ReviewsVariantCHeader;
